// Périodes comptables (année / trimestre / mois) — SOURCE UNIQUE.
// Extrait de src/pages/TableauBord.tsx le 27/10/2026 pour être partagé avec l'écran
// « Recettes & achats » sans dupliquer le calcul des bornes. Comportement inchangé.
// Module PUR (aucun DOM) : testable sous Vitest.

export type PeriodeType = 'annee' | 'trimestre' | 'mois'

export const MOIS = [
  'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre',
]

const pad2 = (n: number): string => String(n).padStart(2, '0')

/** Bornes [debut, fin] (AAAA-MM-JJ, incluses) de la période sélectionnée. */
export function bornes(type: PeriodeType, annee: number, trimestre: number, mois: number): [string, string] {
  if (type === 'annee') return [`${annee}-01-01`, `${annee}-12-31`]
  if (type === 'mois') {
    const dernier = new Date(annee, mois, 0).getDate()
    return [`${annee}-${pad2(mois)}-01`, `${annee}-${pad2(mois)}-${pad2(dernier)}`]
  }
  const moisDebut = (trimestre - 1) * 3 + 1
  const moisFin = moisDebut + 2
  const dernier = new Date(annee, moisFin, 0).getDate()
  return [`${annee}-${pad2(moisDebut)}-01`, `${annee}-${pad2(moisFin)}-${pad2(dernier)}`]
}

export function libellePeriode(type: PeriodeType, annee: number, trimestre: number, mois: number): string {
  if (type === 'annee') return `Année ${annee}`
  if (type === 'mois') return `${MOIS[mois - 1]} ${annee}`
  return `T${trimestre} ${annee}`
}
